export const CUSTOM_CONTENT = 'CUSTOM_CONTENT';
export const CUSTOM_CONTENT_DATA_READY = 'customContentDataReady';
